var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Maps"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34",
    width: 90,
    height: 90,
    rx: 25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Maps_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.4484 23.7313C47.9161 23.2438 46.3174 22.9971 44.7094 23C42.4142 23.0039 40.1477 23.5094 38.0684 24.481C35.9891 25.4527 34.1473 26.867 32.6719 28.625L40.0969 34.8406L49.4484 23.7313Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6719 28.625C30.3028 31.4454 29.0032 35.0104 29.0015 38.6938C28.9674 41.2718 29.5002 43.8258 30.5625 46.175L40.0969 34.8406L32.6719 28.625Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7093 32.7032C45.8461 32.712 46.957 33.0434 47.9128 33.6587C48.8687 34.274 49.6303 35.148 50.109 36.1791C50.5877 37.2101 50.7639 38.3559 50.6171 39.4832C50.4702 40.6104 50.0065 41.6729 49.2796 42.5469L58.6312 31.4376C56.6976 27.7599 53.3937 24.9914 49.4343 23.7313L40.0969 34.8406C40.6638 34.1702 41.3703 33.6316 42.1669 33.2624C42.9636 32.8932 43.8313 32.7023 44.7093 32.7032Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7093 44.6985C43.569 44.6976 42.4525 44.372 41.4904 43.7598C40.5283 43.1477 39.7605 42.2742 39.2766 41.2416C38.7928 40.209 38.613 39.06 38.7582 37.9289C38.9035 36.7979 39.3678 35.7316 40.0969 34.8547L30.5625 46.1891C32.1937 49.8032 34.8937 52.7 37.6922 56.3703L49.2797 42.5891C48.7178 43.2527 48.0175 43.7853 47.228 44.1497C46.4385 44.5141 45.5789 44.7014 44.7093 44.6985Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0546 60.125C54.3 51.9406 60.389 48.2141 60.389 38.6938C60.397 36.1686 59.7939 33.6791 58.6312 31.4376L37.6922 56.3703C38.5781 57.5235 39.4781 58.7609 40.35 60.125C43.5281 65.0469 42.6562 68 44.7093 68C46.7625 68 45.8765 65.0469 49.0546 60.125Z",
    fill: "#34A853"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaps);
export default __webpack_public_path__ + "static/media/Maps.88752f62b293871a95fffca51f7faf45.svg";
export { ForwardRef as ReactComponent };